export default "__VITE_ASSET__398994fc__"